import { render } from "./CelebrationPortrait.vue?vue&type=template&id=bcf99bf0&scoped=true"
import script from "./CelebrationPortrait.vue?vue&type=script&lang=js"
export * from "./CelebrationPortrait.vue?vue&type=script&lang=js"

import "./CelebrationPortrait.vue?vue&type=style&index=0&id=bcf99bf0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf99bf0"]])

export default __exports__